import styled from 'styled-components';

import { darken } from 'polished';

export const Container = styled.div`
  width: 100%;
  padding: 45px 35px;
  height: 100%;
`;
export const Inner = styled.div`
  width: 100%;
  /* height: 685px; */
  height: 100%;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 12px 13px 9px rgba(0, 0, 0, 0.2);
  padding: 28px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h1 {
    width: 100%;
    color: #333333;
    font-size: 30px;
    font-weight: 700;
    text-align: left;
    padding-bottom: 10px;
    padding-right: 70px;
  }
  h2 {
    width: 100%;
    color: #333333;
    font-size: 20px;
    font-weight: 400;
    text-align: left;
    padding-bottom: 20px;
  }
  p {
    width: 100%;
    color: #333333;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    text-align: left;
    white-space: pre-line;
    padding-bottom: 20px;
  }
  button {
    display: block;
    width: 100%;
    max-width: 280px;
    background-color: #ee6255;
    border-radius: 6px;
    padding: 10px 5px;
    margin: auto 0 0;
    color: #fff;
    font-size: 11px;
    font-weight: 700px;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    transition: background-color 0.2s;
    border: 0;
    cursor: pointer;
    &:hover {
      background: ${darken(0.03, '#ee6255')};
    }
  }
  @media (max-width: 1600px) {
    h1 {
      font-size: calc(100vw / 55);
    }
    h2 {
      font-size: calc(100vw / 70);
    }
    p {
      font-size: calc(100vw / 100);
    }
  }
  @media (max-width: 1366px) {
    h1 {
      font-size: 20px;
    }
    h2 {
      font-size: 16px;
    }
    p {
      font-size: 14px;
    }
  }
  @media (max-width: 550px) {
    h1 {
      padding-right: 0;
    }
  }
  @media (max-width: 550px) {
    h1 {
      font-size: 18px;
    }
    h2 {
      font-size: 14px;
    }
    p {
      position: relative;
      max-height: 230px;
      overflow: hidden;
      margin-bottom: 15px;
      &:before,
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
      }
      &:before {
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: 80%;
        /* background-color: red; */
        box-shadow: 0 0 69px 10px rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        margin-bottom: -220px;
      }
      &:after {
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #333333;
      }
    }
  }
`;

export const ImageProject = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  /* width: 109px; */
  /* height: 109px; */
  width: 110px;
  height: 110px;
  background-color: #fff;
  box-shadow: 5px 5px 6px #00000029;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* margin: -38px 40px 0 0; */
  margin: -50px -30px 0 0;
  img {
    width: 80%;
    height: auto;
  }
  @media (max-width: 550px) {
    /*margin: -30px -35px 0 0;*/
    margin: -40px -45px 0 0;
	transform: scale(.90);
  }
`;

export const HighlightContainer = styled.div`
  width: 100%;
  text-align: left;
  padding-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  p {
    width: auto;
    padding: 0;
    font-size: 14px;
    font-weight: 800;
  }
`;
// export const Highlight = styled.ul`
//   flex-grow: 1;
//   /* width: 100%; */
//   /* list-style: disc !important; */
//   color: #856404;
//   padding-left: 10px;
//   /* margin-bottom: 20px; */
//   font-weight: 800;
//   text-transform: uppercase;
//   display: flex;
//   li {
//     font-size: 14px;
//     background-color: #fff3cd;
//     border-radius: 5px;
//     padding: 10px;
//     &:not(:first-child) {
//       display: none;
//     }
//   }
// `;

export const Highlight = styled.div`
  width: 100%;
  /* background-color: #014596; */
  background-color: #fff3cd;
  border-radius: 7px;
  font-weight: 700;
  font-size: 16px;
  /* color: #fff; */
  color: #856404;
  padding: 20px 15px 10px;
  margin-bottom: 30px;
  b {
    display: flex;
    align-items: center;
    svg {
      margin-right: 10px;
    }
  }
  ul {
    list-style: disc;
    padding: 15px 30px 0;
    li {
      font-size: 14px;
      /* color: #fff; */
      color: #856404;
      font-weight: 400;
      margin-bottom: 10px;
    }
  }
`;
